/* tslint:disable */

declare var Object: any;
export interface EncuestaRespuestasDetalleInterface {
  "id": number;
  "preguntaId": number;
  "respuesta": string;
  "encuestaRespuestaId": number;
}

export class EncuestaRespuestasDetalle implements EncuestaRespuestasDetalleInterface {
  "id": number;
  "preguntaId": number;
  "respuesta": string;
  "encuestaRespuestaId": number;
  constructor(data?: EncuestaRespuestasDetalleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EncuestaRespuestasDetalle`.
   */
  public static getModelName() {
    return "EncuestaRespuestasDetalle";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EncuestaRespuestasDetalle for dynamic purposes.
  **/
  public static factory(data: EncuestaRespuestasDetalleInterface): EncuestaRespuestasDetalle{
    return new EncuestaRespuestasDetalle(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EncuestaRespuestasDetalle',
      plural: 'EncuestaRespuestasDetalles',
      path: 'EncuestaRespuestasDetalles',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "preguntaId": {
          name: 'preguntaId',
          type: 'number'
        },
        "respuesta": {
          name: 'respuesta',
          type: 'string'
        },
        "encuestaRespuestaId": {
          name: 'encuestaRespuestaId',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/EncuestaRespuestasDetalle.ts